import React from "react";
import PropTypes from "prop-types";

class BikeNodesApi extends React.Component {
  state = {
    isLoading: true,
    data: null,
    error: false,
    errorMessage: ""
  };

  componentDidMount = () => {
    const { parameters } = this.props;
    const data = {
      lat: parameters.startLocation.lat,
      lng: parameters.startLocation.lng,
      distance: parameters.distance
    };
    const options = {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        "content-type": "application/json"
      }
    };
    fetch("https://conamo-api.herokuapp.com/", options)
      .then(function(response) {
        if (!response.ok) {
          throw Error(response.status);
        }
        return response;
      })
      .then(response => response.json())
      .then(data => {
        this.setState({ data: data, isLoading: false });
      })
      .catch(this.handleError);
  };

  handleError = error => {
    let errorMessage =
      "Er is een fout opgetreden bij het ophalen van de route. Probeer het later nog eens.";
    if (error.message === "400") {
      errorMessage =
        "Er is geen route gevonden in jouw buurt met die parameters.";
    }
    this.setState({ error: true, errorMessage, isLoading: false });
  };

  render() {
    return this.props.render(this.state);
  }
}

BikeNodesApi.propTypes = {
  render: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired
};

export default BikeNodesApi;



// WEBPACK FOOTER //
// ./src/NewRoute/components/BikeNodesApi.js